import React from "react";
import {connect} from "react-redux";
import {formValueSelector, reduxForm} from "redux-form";
import {ff, Form, FormActions, FormBody} from "@mc/mc-legacy";
import EnumSigningLevel from "../../api/gen/qsign/types/EnumSigningLevel";
import EnumSealingLevel from "../../api/gen/qsign/types/EnumSealingLevel";
import EnumSealTimestampLevel from "../../api/gen/qsign/types/EnumSealTimestampLevel";
import EnumSignTimestampLevel from "../../api/gen/qsign/types/EnumSignTimestampLevel";

const validate = (formData, props) => {
  const errors = {};

  if (!formData.name){
      errors.name = "Název nesmí být prázdný";
  }
  if (!formData.code){
      errors.code = "Kód nesmí být prázdný";
  }
  if (props.initialValues.codes.includes(formData.code)) {
    errors.code = "Code musí být unikátní";
  }
  if (!formData.signatureLevel) {
    errors.signatureLevel="Úroveň podpisu nesmí být prázdná"
  }
  if (!formData.signatureTimestampLevel) {
    errors.signatureTimestampLevel="Úroveň podpisu časového razítka nesmí být prázdná"
  }
  if (!formData.sealLevel) {
    errors.sealLevel="Úroveň pečetění nesmí být prázdná"
  }
  if (!formData.sealTimeStampLevel) {
    errors.sealTimeStampLevel="Úroveň pečetění časového razítka nesmí být prázdná"
  }
  return errors;
};
const itemySign = [
  { id: EnumSigningLevel.QUALIFIED, name: "Kvalifikovaný" },
  { id: EnumSigningLevel.GUARANTEED, name: "Zaručený" },
  { id: EnumSigningLevel.NONE, name: "Žádná" },
];

const itemySeal = [
  { id: EnumSealingLevel.QUALIFIED, name: "Kvalifikovaný" },
  { id: EnumSealingLevel.GUARANTEED, name: "Zaručený" },
  { id: EnumSealingLevel.NONE, name: "Žádná" },
];

const itemsTimestompSeal = [
  { id: EnumSealTimestampLevel.QUALIFIED, name: "Kvalifikovaný" },
  { id: EnumSealTimestampLevel.GUARANTEED, name: "Zaručený" },
  { id: EnumSealTimestampLevel.NONE, name: "Žádná" },
];

const itemsTimestompSign = [
  { id: EnumSignTimestampLevel.QUALIFIED, name: "Kvalifikovaný" },
  { id: EnumSignTimestampLevel.GUARANTEED, name: "Zaručený" },
  { id: EnumSignTimestampLevel.NONE, name: "Žádná" },
];


class KombinaceForm extends React.Component {
  static formName = "KombinaceForm";
  onChangesignatureLevel() {
    this.props.change("signatureTimestampLevel", "NONE");
  }
  onChangesealLevel() {
    this.props.change("sealTimeStampLevel", "NONE");
  }
  render() {
    const { onClose, submitting, values, change, handleSubmit } = this.props;

    return (
      <Form onSubmit={handleSubmit}>
        <FormBody>
          <ff.String required name="name" label="Název" />
          {this.props.name && <ff.String required name="code" label="Kód" />}
          {this.props.code && (
            <ff.Autocomplete
              required
              items={itemySign}
              useIdAsValue={true}
              name="signatureLevel"
              label="Úroveň podpisu"
              onChange={() => {
                this.onChangesignatureLevel();
              }}
            />
          )}
          {this.props.signatureLevel !=EnumSigningLevel.NONE &&(
             <ff.Autocomplete
             initialValue={EnumSigningLevel.NONE}
              items={itemsTimestompSign}
              useIdAsValue={true}
              name="signatureTimestampLevel"
              label="Ůroveň časového razítka"
              onChange={() => {
                console.log("test");
              }}
            />
          )}
          {this.props.code && (
            <ff.Autocomplete
              items={itemySeal}
              required
              useIdAsValue={true}
              name="sealLevel"
              onChange={() => {
                this.onChangesealLevel();
              }}
              label="Ůroveň pečetě"
            />
          )}
          {this.props.sealLevel !== "NONE" && (
            <ff.Autocomplete
              items={itemsTimestompSeal}
              useIdAsValue={true}
              name="sealTimeStampLevel"
              label="Ůroveň časového razítka"
            />
          )}
        </FormBody>
        <FormActions onClose={onClose} storeButton cancelButton disabled={submitting} />
      </Form>
    );
  }
}
function mapStateToProps(state) {
  const selector = formValueSelector(KombinaceForm.formName);
  return {
    id: selector(state, "id"),
    name: selector(state, "name"),
    code: selector(state, "code"),
    signatureLevel: selector(state, "signatureLevel"),
    signatureTimestampLevel: selector(state, "signatureTimestampLevel"),
    sealLevel: selector(state, "sealLevel"),
    sealTimeStampLevel: selector(state, "sealTimeStampLevel"),
  };
}
export default connect(mapStateToProps)(
  reduxForm({
    initialValues: {},
    form: KombinaceForm.formName,
    validate: validate,
  })(KombinaceForm)
);
